import { CSSObject } from '@emotion/react'
import { CSSProperties } from 'react'
import { sharedColors } from '../../../sharedStyles/styles'

export const accountWrapper: CSSObject = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  fontWeight: 'bold',
}

export const accountAvatar: CSSObject = {
  flexShrink: 0,
  marginRight: '8px',
  img: {
    height: '100%',
    objectFit: 'cover',
  },
}

export const collabAvatarSecondary: CSSObject = {
  ...accountAvatar,
  backgroundColor: 'rgb(208, 218, 225)',
  marginLeft: -10,
}

export const collabSeparator: CSSProperties = {
  color: sharedColors.white,
  flexShrink: 0,
  fontSize: 14,
  fontWeight: 'normal',
  whiteSpace: 'pre',
}

export const withCollab = 'with-collab'
const withCollabSelector = `.kuiper-${withCollab}`

export const nameRow: CSSObject = {
  alignItems: 'baseline',
  display: 'flex',
  [`&${withCollabSelector}`]: {
    flex: '1 1 auto',
    minWidth: 0,
    overflow: 'hidden',
  },
  [`&${withCollabSelector} .kuiper-account-name`]: {
    display: 'block',
    flex: '0 1 auto',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}

export const contentWrapper: CSSObject = {
  boxSizing: 'border-box',
  bottom: '20px',
  color: sharedColors.white,
  display: 'flex',
  flex: '1',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  padding: '16px',
  position: 'absolute',
  rowGap: '12px',
  width: '434px',
  zIndex: 1000,
}

export const captionAndAccountWrapper: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  rowGap: '12px',
}

export const paidPromotion: CSSObject = {
  alignItems: 'center',
  backgroundColor: sharedColors.black + '50',
  borderRadius: '4px',
  display: 'flex',
  fontSize: '12px',
  fontWeight: 'bold',
  height: '18px',
  justifyContent: 'center',
  marginLeft: '2px',
  width: '148px',
}

export const input = (readOnly: boolean): CSSObject => {
  const base = {
    backgroundColor: 'transparent',
    color: sharedColors.white,
    padding: 0,
    width: '100%',
  }

  const editable = {
    '&:hover': {
      backgroundColor: sharedColors.inputHover,
    },
  }

  return {
    ...base,
    ...(!readOnly ? editable : {}),
  }
}

export const captionInput = (readOnly: boolean): CSSObject => ({
  ...input(readOnly),
  width: 400,
  maxHeight: '44px',
  // Override default styles for `highlightSocialTags` prop
  '.social-link-match': {
    color: `${sharedColors.white} !important`,
    fontWeight: 'bold',
  },
})

export const inputPlaceholder: CSSObject = {
  color: sharedColors.white,
  opacity: 0.9,
}

export const iconsBar: CSSObject = {
  alignItems: 'flex-end',
  backgroundColor: '#182229',
  display: 'flex',
  height: '772px',
  justifyContent: 'center',
  padding: '0 6px',
  position: 'absolute',
  right: 0,
  width: '54px',
  zIndex: 1,
  '& > ul': {
    alignItems: 'center',
    color: sharedColors.white,
    display: 'flex',
    flexDirection: 'column',
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    rowGap: '20px',
  },
}

export const iconBarItemIconWrapper: CSSObject = {
  backgroundColor: sharedColors.medGray + '80',
  borderRadius: '50%',
  display: 'flex',
  height: '46px',
  justifyContent: 'center',
  width: '46px',
}

export const iconBarItemIconSoundWrapper: CSSObject = {
  backgroundColor: sharedColors.black + '80',
  borderRadius: '6px',
  border: `1px solid ${sharedColors.white}`,
  color: sharedColors.lightGray + '80',
  display: 'flex',
  height: '38px',
  justifyContent: 'center',
  marginBottom: '4px',
  width: '38px',
}

export const iconBarItem: CSSObject = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  fontSize: '14px',
  rowGap: '8px',
}

export const bottomGradient: CSSObject = {
  background: `linear-gradient(0deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0) 100%)`,
  display: 'flex',
  flex: '1',
  flexDirection: 'column',
  height: '120px',
  justifyContent: 'flex-end',
  position: 'absolute',
  top: '652px',
  width: '434px',
  zIndex: 0,
}
